module.exports = __webpack_public_path__ + "img/img_sec5_02.7dba4f8d.jpg";